import { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import SetDefaultValues from './SetDefaultValues';
import SetPassword from './SetPassword';
import * as actions from '../../actions';
import type { Notify } from '../../typings/redux';

interface RegistrationProcess {
  setPassword: boolean;
  setDefaultValues: boolean;
  [key: string]: any;
}

interface Environment {
  isMobileDevice: boolean;
  [key: string]: any;
}

interface TaxSettings {
  [key: string]: any;
}

interface SetupAccountProps {
  registrationProcess: RegistrationProcess;
  taxSettings?: TaxSettings;
  notify: Notify;
  whiteLabel: boolean;
  userType: string;
  environment: Environment;
  languageSoftware: number;
  first_name: string;
}

interface SetupAccountState {
  showVideo: boolean;
}

class SetupAccount extends Component<SetupAccountProps, SetupAccountState> {
  constructor(props: SetupAccountProps) {
    super(props);

    this.state = {
      showVideo: !props.environment.isMobileDevice && props.languageSoftware === 0
    };
  }

  getStepElement(registrationProcess: RegistrationProcess) {
    if (registrationProcess.setPassword === false) {
      return (
        <Col sm="12" md="12" lg="5" className="mb-4">
          <SetPassword />
        </Col>
      );
    }
    if (registrationProcess.setDefaultValues === false) {
      return (
        <Col sm="12" md="12" lg="5" className="mb-4">
          <SetDefaultValues />
        </Col>
      );
    }

    return null;
  }

  render() {
    const { registrationProcess } = this.props;

    return registrationProcess ? (
      <div className="animated fadeIn m-t-30">
        <Row className="justify-content-center">{this.getStepElement(registrationProcess)}</Row>
      </div>
    ) : null;
  }
}

function mapStateToProps({
  auth: { registrationProcess, whiteLabel, type, languageSoftware, first_name },
  notify,
  environment
}: any) {
  return {
    registrationProcess,
    notify,
    whiteLabel,
    userType: type,
    environment,
    languageSoftware,
    first_name
  };
}

export default connect(mapStateToProps, actions)(SetupAccount);
